import { USERS_ENDPOINT } from "api/endpoints";
import { ButtonV2 } from "components/Button";
import { ErrorWrapper } from "components/ErrorWrapper";
import { FormField, FormFieldNative } from "components/Form";
import { Input } from "components/Input";
import Logo from "components/Logo";
import { useRouter } from "next/router";
import { FormEventHandler, useState } from "react";
import { toast } from "react-toastify";

export default function RegisterPage() {
  const { query: { redir } } = useRouter()
  const [errors, setErrors] = useState<Record<string, string>>({})
  const [privacy, setPrivacy] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const router = useRouter()
  const onSubmit: FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault()
    const form = new FormData(e.currentTarget)


    const errors: Record<string, string> = {}
    const registerData = Object.fromEntries(form) as Partial<{
      first_name: string
      second_name: string
      middle_name: string
      nickname: string
      email: string
      password: string
      author_id?: string
      spin?: string
      orcid?: string
    }>




    if (Object.keys(errors).length > 0) {
      setErrors(errors)
      return
    }

    const resp = await fetch(USERS_ENDPOINT, { method: 'POST', body: JSON.stringify(registerData) })
    if (resp.status == 409) {
      toast.error('Аккаунт с данным именем пользователя или логином уже существует')
      return
    }
    if (!resp.ok) {
      toast.error('Что-то пошло не так')
      return
    }

    if (!redir)
      router.push('/login')
    else window.location.href = '/login' + '?redir=' + encodeURIComponent(redir as string)

  }

  return <div className="flex flex-col gap-0 w-full">
    <div className="px-2 py-1 fixed"><Logo width={100} height={100} /></div>
    <div className="h-screen flex flex-col gap-2 items-center justify-center">
      <form className="flex flex-col gap-2 p-2 border-light-grey border w-35 rounded-md" onSubmit={onSubmit}>
        <h1 className="text-2xl font-bold">Регистрация</h1>
        <div className="flex flex-row gap-1">
          <FormFieldNative name="Имя" required className="flex-1">
            <ErrorWrapper error={errors['first_name']}>
              <Input className="w-full" name="first_name" required autoComplete="given-name" pattern="[А-Яёа-я]+" placeholder="Иван" maxLength={20} />
            </ErrorWrapper>
          </FormFieldNative>
          <FormFieldNative name="Фамилия" required className="flex-1">
            <ErrorWrapper error={errors['second_name']}>
              <Input className="w-full" name="second_name" required autoComplete="family-name" pattern="[А-Яёа-я]+" placeholder="Иванов" maxLength={20} />
            </ErrorWrapper>
          </FormFieldNative>
        <FormFieldNative name="Отчество" required className="flex-1">
          <ErrorWrapper error={errors['middle_name']}>
            <Input className="w-full" name="middle_name" required autoComplete="additional-name" pattern="[А-Яёа-я]+" placeholder="Иванович" maxLength={20} />
          </ErrorWrapper>
        </FormFieldNative>
        </div>

        <div className="flex flex-row gap-1">
          <FormFieldNative name="Имя пользователя" required className="flex-1">
            <ErrorWrapper error={errors['nickname']}>
              <Input className="w-full" name="nickname" required autoComplete="username" pattern="[a-zA-Z0-9._\-]+" placeholder="my_username" maxLength={20} />
            </ErrorWrapper>
          </FormFieldNative>
          <FormFieldNative name="E-mail" required className="flex-1">
            <ErrorWrapper error={errors['email']}>
              <Input className="w-full" name="email" required type="email" autoComplete="email" defaultValue={router.query.email as string | undefined ?? undefined} placeholder="test@example.com" maxLength={50} />
            </ErrorWrapper>
          </FormFieldNative>
        </div>
        <FormFieldNative name="Пароль" required>
          <ErrorWrapper error={errors['password']}>
            <Input className="w-full" name="password" type={showPassword ? "text" : "password"} required autoComplete="new-password" />
            <button className="text-left underline mt-0.5 w-full" onClick={() => setShowPassword(!showPassword)}>{showPassword ? 'Скрыть' : 'Показать'} пароль</button>
          </ErrorWrapper>
        </FormFieldNative>

        <div className="flex flex-row gap-1">
          <FormFieldNative name="Author ID">
            <Input className="w-full" name="author_id" pattern="[0-9]+" placeholder="000000" />
          </FormFieldNative>
          <FormFieldNative name="SPIN">
            <Input className="w-full" name="spin" pattern="[0-9]{4}-[0-9]{4}" placeholder="0000-0000" />
          </FormFieldNative>
          <FormFieldNative name="ORCID">
            <Input className="w-fit" name="orcid" pattern="[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}" placeholder="0000-0000-0000-0000" />
          </FormFieldNative>
        </div>

        <div className="flex flex-col gap-0.5">
          <label>
            <input type="checkbox" className="mr-0.5" checked={privacy} onChange={e => setPrivacy(e.target.checked)} />
            С <a href="/privacy" target="_blank" className="underline text-secondary" rel="noreferrer">политикой конфиденциальности</a> согласен, условия обработки персональных данных принимаю
          </label>
        </div>

        <div className="flex flex-row gap-1">
          <ButtonV2 type="submit" className="flex-1" disabled={!privacy}>Зарегистрироваться</ButtonV2>
          <ButtonV2 onClick={() => {
            if (!redir)
              router.push('/login')
            else router.push('/login?redir=' + encodeURIComponent(redir as string))
          }} colorscheme="default-outline" className="flex-1">Войти</ButtonV2>
        </div>
      </form>
    </div>
  </div>

}
